module.exports = __webpack_public_path__ + "static/img/circle_03.0f52bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle_03.png
// module id = j3R1
// module chunks = 1